import React from 'react';

export default () => (
  <svg width="22" height="22" viewBox="0 0 19 15">
    <g fill="none" fillRule="evenodd" stroke="#004363" strokeWidth="2">
      <path d="M.68066406 1.14550781H18.3535156M8 7.14550781h10.3535156M.68066406 13.1455078H18.3535156" />
    </g>
  </svg>
);
